module.exports = __webpack_public_path__ + "img/header-engagementRingsFastDelivery.f9af705.webp";